import { EmptyState } from "./Surfaces";

/** Inline loading block for the screens that predate the design system. */
export function Spinner({ label = "Ładowanie…" }: { label?: string }) {
  return <EmptyState variant="loading" title={label} className="border-0" />;
}
